import Alert from '@amzn/meridian/alert';
import AppLayout from '@amzn/meridian/app-layout';
import Column from '@amzn/meridian/column';
import Heading from '@amzn/meridian/heading';
import MastheadTitle from '@amzn/meridian/masthead';
import Row from '@amzn/meridian/row';
import Toaster from '@amzn/meridian/toaster';
import React, { useState } from 'react';

import { SwitchButtonValue } from '../components/agile/types/zoneMapType';
import ProductCreationMenu from '../components/productGroups/productCreationMenu';
import ProductTable from '../components/productGroups/productTable';
import { ProductData } from '../types/productTypes';

interface Toast {
  id: string;
  type: 'success' | 'error' | 'informational';
  message: string;
  timeout?: number;
}

type ProductViewType = SwitchButtonValue | 'Product Table';

const ProductGroupsPage: React.FC = () => {
  const [switchButtonValue] = useState<ProductViewType>('Product Table');
  const [toasts, setToasts] = useState<Toast[]>([]);

  const [productData, setProductData] = useState<ProductData>({
    productItems: [],
    productGroupId: '',
    categoryData: '',
    extraDimension: '',
    subcategoryData: '',
    isLoading: false,
  });
  const handleProductDataUpdate = (data: ProductData) => {
    setProductData(data);
  };

  // create a new toast with unique id to add to state
  const handleToastChange = (type: 'success' | 'error' | 'informational', message: string, timeout?: number) => {
    const newToast = {
      id: `toast-${Date.now()}`,
      type,
      message,
      timeout,
    };
    setToasts((prevToasts) => [...prevToasts, newToast]);
  };

  // removes the toast by references to unique id
  const handleCloseToast = (id: string) => {
    setToasts((prevToasts) => prevToasts.filter((toast) => toast.id !== id));
  };

  return (
    <AppLayout
      headerComponent={
        <MastheadTitle backgroundColor="secondary">
          <Heading level={3} alignment="left">
            Product Groups
          </Heading>
        </MastheadTitle>
      }
    >
      {/* Add toaster to display embedded with alert message */}
      <Toaster toasts={toasts} onCloseToast={handleCloseToast} alignmentHorizontal="center" alignmentVertical="top">
        {/* use alert to display as a toast message spanning screen */}
        {(toast: Toast) => (
          <Alert toast onClose={() => handleCloseToast(toast.id)} type={toast.type} size="large">
            {toast.message}
          </Alert>
        )}
      </Toaster>
      <Row width="100%" height="100%">
        <Column width="400px" height="100%" backgroundColor="white">
          <ProductCreationMenu
            switchButtonValue={switchButtonValue}
            onDataUpdate={handleProductDataUpdate}
            onToastChange={handleToastChange}
          />
        </Column>
        <Column width="calc(100% - 400px)" height="100%" spacingInset="400">
          {switchButtonValue === 'Product Table' && (
            <ProductTable
              productGroupData={productData.productItems}
              productGroupId={productData.productGroupId}
              categoryData={productData.categoryData}
              extraDimension={productData.extraDimension}
              subcategoryData={productData.subcategoryData}
              isLoading={productData.isLoading}
            />
          )}
        </Column>
      </Row>
    </AppLayout>
  );
};
export default ProductGroupsPage;
